var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#92AFEF;}\n\t.st1{fill:none;stroke:#A977F9;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.3,20.5c0,0,10.4-7.1,1.5-14.3c-1.9-0.9-5-2.4-8.8,1.4c-0.4,0.7-0.9,1.2-2-0.1C29,6.2,22.6,2,18.4,10.2 c-0.3,1.4-1.7,5.7,6.5,12.3c3,2.8,3.7,4,3.7,4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "32.7,14.5 32.7,12.1 29.4,12.1 29.4,14.1 27.2,14.1 27.2,17.5 29.5,17.5 29.5,19.9 32.7,19.9  32.7,17.5 35.2,17.5 35.2,14.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 38.1,
    y1: 21.7,
    x2: 33.5,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.9,30.2v-3.6c0,0,0-1.5,1.4-1.5s5.2,0,5.2,0s1.2,0,1.2,1.5s0,8.5,0,8.5s0.4,2-1.5,1.9c-1.9-0.1-4.8,0-4.8,0 s-1.4,0.5-1.4-1.8s0-3,0-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.7,35.1c0,0,5.4,1.4,6.1,1.5c0.7,0.2,6.3,1.5,11-0.4c4.1-0.8,8.2-1.7,8.2-1.7s3.8-0.3,3.5-3.8 c-0.2-0.6-0.4-1.8-4.1-1.6c-2.8,0.1-6.2,0.4-6.2,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.6,32H33c0,0,3.3-0.4,2.6-3.3c-0.4-1.2,0.4-2.8-6.2-2.2c-3.8-0.3-5.5-0.7-6.3-0.7s-4.3-0.1-5.5,0.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthScore);
export default __webpack_public_path__ + "static/media/Health-Score.81e535a241ecbee59c603920584ebf34.svg";
export { ForwardRef as ReactComponent };